import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIContractClientDtoResponse, ContractClientDto } from '../types/api'
import { CLIENT_CONTRACTS_PATH } from '../types/constants'
import { ContractType } from '../types/general'

export interface ClientGetServiceAgreementOptions {
  hasSharedCRM: boolean
}

export const ClientContractsService = {
  listServiceAgreements: (
    locationId: string,
    { hasSharedCRM }: ClientGetServiceAgreementOptions
  ): Promise<APIContractClientDtoResponse | null> =>
    requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: {
        type: ContractType.ServiceAgreement,
        ...(hasSharedCRM && { includeShared: true, includes: ['location'] }),
      },
    }),

  getContract: (
    locationId: string,
    id: string,
    { hasSharedCRM }: ClientGetServiceAgreementOptions
  ): Promise<ContractClientDto | null> =>
    // Client API is not allowed to get contract by id
    requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: {
        ...(hasSharedCRM && { includeShared: true, includes: ['location'] }),
      },
    }).then((res) => res?.results?.find((c) => c.id === id) ?? null),
}
